import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment'
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import OverwriteScheduleForm from '../project/OverwriteScheduleForm.vue'
import RescheduleForm from '../project/RescheduleForm.vue'
import { ref, reactive, onMounted } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { bulkOverwriteSchedule, bulkReschedule } from '@/api/jobs'

interface Data {
  scheduleOption: 'delay' | 'expedite' | 'overwrite'
  timeDeltaUnit: 'day' | 'hour'
  timeDeltaQuantity: number
  startTime: moment.Moment | null
  endTime: moment.Moment | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUpdateScheduleForm',
  props: {
    buttonLabel: null,
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
}





const error = ref(false)
const saving = ref(false)

const data: Data = reactive({
  scheduleOption: 'delay',
  timeDeltaUnit: 'day',
  timeDeltaQuantity: 1,
  startTime: null,
  endTime: null,
})

onMounted(() => {
  data.startTime = defaultStartTime()
  data.endTime = defaultEndTime()
})

// Reschedule all job start and end times by the same time delta
const reschedule = async () => {
  saving.value = true
  try {
    await bulkReschedule(
      props.selectedJobs.map((job) => job.number),
      timeDeltaInSeconds()
    )
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        requested_start: moment(job.requested_start)
          .add(timeDeltaInSeconds(), 'seconds')
          .toISOString(),
        requested_end: moment(job.requested_end)
          .add(timeDeltaInSeconds(), 'seconds')
          .toISOString(),
      })
    )
    emits('updated', { message: 'Schedule updated', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}
const timeDeltaInSeconds = (): number => {
  let amount = data.timeDeltaQuantity

  if (data.timeDeltaUnit === 'day') {
    amount = amount * 24
  }

  if (data.scheduleOption === 'expedite') {
    amount = amount * -1
  }

  return amount * 3600
}
const updateTimeDeltaQuantity = (value: string) =>
  (data.timeDeltaQuantity = parseInt(value, 10))
const updateTimeDeltaUnit = (value: 'day' | 'hour') =>
  (data.timeDeltaUnit = value)

// Overwrite all jobs to have the same start and end time
const overwriteSchedule = async () => {
  saving.value = true
  try {
    await bulkOverwriteSchedule(
      props.selectedJobs.map((job) => job.number),
      data.startTime,
      data.endTime
    )
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        requested_start: data.startTime?.toISOString(),
        requested_end: data.endTime?.toISOString(),
      })
    )
    emits('updated', { message: 'Schedule updated', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}

const defaultStartTime = (): moment.Moment | null => {
  const startTimes = new Set(
    props.selectedJobs.map((job) => job.requested_start)
  )
  return startTimes.size === 1 ? moment([...startTimes][0]) : null
}

const defaultEndTime = (): moment.Moment | null => {
  const endTimes = new Set(props.selectedJobs.map((job) => job.requested_end))
  return endTimes.size === 1 ? moment([...endTimes][0]) : null
}
const updateStartTime = (value: moment.Moment) => (data.startTime = value)
const updateEndTime = (value: moment.Moment) => (data.endTime = value)

const save = () => {
  if (data.scheduleOption === 'overwrite') {
    overwriteSchedule()
  } else {
    reschedule()
  }
}

const clearSnackbar = () => (error.value = false)
const dismiss = () => emits('dismiss')

return { __sfc: true,emits, props, error, saving, data, reschedule, timeDeltaInSeconds, updateTimeDeltaQuantity, updateTimeDeltaUnit, overwriteSchedule, defaultStartTime, defaultEndTime, updateStartTime, updateEndTime, save, clearSnackbar, dismiss, BulkUpdateWrapper, OverwriteScheduleForm, RescheduleForm }
}

})